import { DialogModalSize, DialogRef } from './dialog-ref';
import { Injectable } from "@angular/core";


@Injectable()
export class DialogConfig<D = any> {
  data?: D;
  config?: D;
  size?: DialogModalSize;
  title?: D;
  popupConfig?: D;
  //adding this as smartmodelservice supports these will be depricated once all moved to data
  layout_type?: D;
  getdata?: D;
  resource?: D;
  isEditableGrid?:D;
  // ref?: DialogRef;
}
